import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  root: {
    [theme.breakpoints.down('md')]: {
      position: 'relative',
      order: -2,
    },
  },
}));

function Top({ children }) {
  const { classes } = useStyles();
  return (
    <Grid classes={classes} item xs="auto" md={12}>
      {children}
    </Grid>
  );
}

Top.propTypes = {
  children: PropTypes.node.isRequired,
};

export default memo(Top);
